import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "../AnswerCard/AnswerCardStyles.css";
export default function CarouselImage({ attachments }) {
  return (
    <div className="imageAttachmentBoxAB">
      <Carousel>
        {attachments.map((image) => {
          return (
            <div key={image.name}>
              <img src={image.src} />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}
